import _ from "underscore";
import Backbone from 'backbone';
import DefaultController from "./default-controller";
import LoginView from '../comp-view/login-view';
import i18next from "i18next";

export default class LoginController extends DefaultController {

  constructor(props) {
    super(props);
    this.model = new Backbone.Model({email: '', password: '', notification: undefined});
    _.extend(this, Backbone.Events);
  }

  init(options) {
    this.view = new LoginView({model: this.model});
    this.listenTo(this.view, 'login', this.login);
    return super.init();
  }

  login() {
    const self = this;
    firebase.auth().signInWithEmailAndPassword(this.model.get('email'), this.model.get('password'))
        .then(() => {
          window.location = "#";
        })
        .catch(function (error) {
          self.model.set('notification', i18next.t("login.notification.email-or-password-invalid"));
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log('login failed.', errorCode, errorMessage);
        });
  }

  start() {
    this.view.render();
    return super.start();
  }

  stop() {
    this.stopListening(this.view);
    return super.stop();
  }

  destroy() {
    this.view.remove();
    return super.destroy();
  }
}
